export const RICH_TYPE = {
  LINK: 'LINK',
  UNORDERED_LIST: 'unordered-list-item',
  UNORDERED_LIST_SWITCHER: 'unordered-list-item-switcher',
  ORDERED_LIST: 'ordered-list-item',
  BOLD: 'BOLD',
  UNDERLINE: 'UNDERLINE',
  ITALIC: 'ITALIC',
  TEXT_COLOR: 'TEXT_COLOR',
  FONT_SIZE: 'FONT_SIZE',
};

// toolbar的颜色选择器枚举
// 同时也传给draftjs一个映射关系【没这个映射关系就得用另外一个方案，需要安包。我这边安包不方便，所以就用的这个demo】
function getFullColors(uniqueColors = {}) {
  return {
    ...uniqueColors,
    '#e0301e': {
      // Red
      color: 'rgb(224, 48, 30, 1)',
    },
    '#d04a02': {
      // Orange
      color: 'rgb(208, 74, 2, 1)',
    },
    '#eb8c00': {
      // Orange
      color: 'rgb(235, 140, 0, 1)',
    },
    '#ffb600': {
      // Gold
      color: 'rgb(255, 182, 0, 1)',
    },
    '#299d8f': {
      // Blue-green
      color: 'rgb(41, 157, 143, 1)',
    },
    '#0081e9': {
      // Blue
      color: 'rgb(0, 129, 233, 1)',
    },
  };
}

export const colorStyleMap = getFullColors({
  '#dbdbdb': {
    // Light grey
    color: 'rgb(219, 219, 219, 1)',
  },
  '#7d7d7d': {
    // Grey
    color: 'rgb(125, 125, 125, 1)',
  },
});
export const colorStyleMapLightMode = getFullColors({
  '#252525': {
    // Grey
    color: 'rgb(37, 37, 37, 1)',
  },
  '#696969': {
    // Light grey
    color: 'rgb(105, 105, 105, 1)',
  },
});

// 改的时候千万注意下面这俩个的key还有value里面的color的值与上面的俩个的关系
export const compatibleStyleForDarkMode = {
  '#252525': {
    color: 'rgb(219, 219, 219, 1)',
  },
  '#696969': {
    // Light grey
    color: 'rgb(125, 125, 125, 1)',
  },
};

export const compatibleStyleForLightMode = {
  '#dbdbdb': {
    // Grey
    color: 'rgb(37, 37, 37, 1)',
  },
  '#7d7d7d': {
    // Light grey
    color: 'rgb(105, 105, 105, 1)',
  },
};

const fontSizePrefix = 'fontSize-'; // for more readable code
export const fontSizeConfig = [14, 16, 18, 20, 22, 24, 36, 72];

export const fontSizeOptions = fontSizeConfig.map((i) => ({
  label: i,
  value: fontSizePrefix + i,
}));

export const fontSizeStyleMap = fontSizeOptions.reduce((sum, current) => {
  sum[current.value] = { fontSize: `${current.label}px` };
  return sum;
}, {});

const getHTMLStyles = (editorStyle) => {
  let matches;
  if ((matches = editorStyle.match(/fontSize-(.*)/))) {
    return { fontSize: `${matches[1]}px` };
  } else if ((matches = editorStyle.match(/#(.*)/))) {
    return { color: matches[1] };
  } else if ((matches = editorStyle.match(/fontFamily-(.*)/))) {
    return { fontFamily: matches[1] };
  }
  return {};
  // switch (editorStyle) {
  //   case 'BOLD':
  //     return { fontWeight: 'bold' };
  //   case 'ITALIC':
  //     return { fontStyle: 'italic' };
  //   case 'SUPERSCRIPT':
  //     return { fontSize: '.7rem', position: 'relative', top: '-.5rem' };
  //   case 'SUBSCRIPT':
  //     return { fontSize: '.7rem', position: 'relative', bottom: '-.5rem' };
  //   case 'UNDERLINE':
  //     return { textDecoration: 'underline' };
  //   case 'STRIKETHROUGH':
  //     return { textDecoration: 'line-through' };
  //   default:
  //     return {};
  // }
};

const getListItemClassName = (style, contentBlock) => {
  const emptyStyleList = contentBlock?.getData()?.get('emptyStyle');
  if (emptyStyleList?.size && contentBlock.getLength() === 0) {
    // apply default style for empty block
    const defaultFontSize = emptyStyleList
      .toArray()
      .find((i) => i && i.startsWith('fontSize'));
    if (defaultFontSize) {
      const fontSize = defaultFontSize.split('-')[1];
      return `list-first-letter-font-size-${fontSize}`;
    }
  }
  if (!style.fontSize || typeof style.fontSize !== 'string') {
    return `list-first-letter-font-size-14`;
  }
  const fontSize = style.fontSize.replace('px', '');
  return `list-first-letter-font-size-${fontSize}`;
};

export const blockStyleFn = (contentBlock) => {
  const type = contentBlock.getType();
  if (type === 'ordered-list-item') {
    const styleImmutable = contentBlock.getInlineStyleAt(0);
    const htmlStyle = styleImmutable
      .map((style) => getHTMLStyles(style))
      .toArray()
      .reduce((acc, style) => ({ ...acc, ...style }), {});
    return getListItemClassName(htmlStyle, contentBlock);
  }
};
